import { Params } from '@/@types/routes'

export const toQueryString = (params: Params): string => {
  const query = new URLSearchParams()

  for (const key in params) {
    const value = params[key]
    if (value) {
      query.set(key, value)
    }
  }

  return query.toString()
}
